import { render, staticRenderFns } from "./live-mina.vue?vue&type=template&id=602cd0ad&"
import script from "./live-mina.vue?vue&type=script&lang=js&"
export * from "./live-mina.vue?vue&type=script&lang=js&"
import style0 from "./live-mina.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports